/**
 * Ждёт выполнения telegram-web-app.js (Promise из index.html).
 * В обычном вебе скрипт не грузится — Promise уже resolved.
 */
export function awaitTelegramWebApp(): Promise<void> {
  const ready = window.__tgWebAppReady
  if (ready && typeof ready.then === 'function') {
    return ready
  }
  // Fallback: скрипт уже есть / Promise не выставлен (тесты, HMR)
  return Promise.resolve()
}
